import { useEffect } from "react";

const CLARITY_ID = "viaqs7mvlh";
const COOKIE_CONSENT_KEY = "cc_cookie_consent";

function injectClarity() {
  if (document.getElementById("clarity-script")) return;
  const script = document.createElement("script");
  script.id = "clarity-script";
  script.type = "text/javascript";
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_ID}`;
  document.head.appendChild(script);

  (window as any).clarity = (window as any).clarity || function (...args: any[]) {
    ((window as any).clarity.q = (window as any).clarity.q || []).push(args);
  };
}

function updateGoogleConsent(granted: boolean) {
  if (typeof (window as any).gtag === "function") {
    (window as any).gtag("consent", "update", {
      analytics_storage: granted ? "granted" : "denied",
    });
  }
}

function hasAnalyticsConsent(): boolean {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return false;
    return JSON.parse(raw)?.analytics === true;
  } catch {
    return false;
  }
}

function applyConsent() {
  const granted = hasAnalyticsConsent();
  updateGoogleConsent(granted);
  if (granted) {
    injectClarity();
  }
}

export function useAnalytics() {
  useEffect(() => {
    applyConsent();

    const onStorage = (e: StorageEvent) => {
      if (e.key === COOKIE_CONSENT_KEY) applyConsent();
    };
    const onConsent = () => applyConsent();

    window.addEventListener("storage", onStorage);
    window.addEventListener("cookie-consent-update", onConsent);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("cookie-consent-update", onConsent);
    };
  }, []);
}
